import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import About from './components/About';
import Services from './components/Services';
import Process from './components/Process';
import Projects from './components/Projects';
import Technology from './components/Technology';
import WhyChooseUs from './components/WhyChooseUs';
// import Testimonials from './components/Testimonials'; // Removed - using real testimonials later
import QuoteForm from './components/QuoteForm';
import CallToAction from './components/CallToAction';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Stats />
      <About />
      <Services />
      <Process />
      <Projects />
      <Technology />
      <WhyChooseUs />
      {/* <QuoteForm /> */}
      <CallToAction />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
